.e6{aspect-ratio:1/1;}